import React from 'react';

export default(key, lang) => {
  let mapping = {
    title: {
      en_US: 'Mobile Phone Verification',
      de_DE: 'Handy-Überprüfung',
      el_GR: 'Επαλήθευση κινητού τηλεφώνου',
      es_ES: 'Verificación de teléfono móvil',
      fr_FR: 'Vérification de téléphone portable',
      fr_CA: 'Vérification de téléphone portable',
      it_IT: 'Verifica del telefono cellulare',
      pl_PL: 'Weryfikacja telefonu komórkowego',
      th_TH: 'การยืนยันโทรศัพท์มือถือ',
      zh_CN: '手机验证',
      pt_BR: 'Verificação do telefone móvel',
      ja_JP: '携帯電話の検証',
    },
    submitText: {
      en_US: 'Verify Code',
      de_DE: 'Code überprüfen',
      el_GR: 'Επαλήθευση κωδικού',
      es_ES: 'Verifique el Código',
      fr_FR: 'Vérifier le code',
      fr_CA: 'Vérifier le code',
      it_IT: 'Verificare il codice',
      pl_PL: 'Zweryfikuj kod',
      th_TH: 'ตรวจสอบรหัส',
      zh_CN: '验证码',
      pt_BR: 'Código de verificação',
      ja_JP: 'コードを確認する',
    },
    cancelText: {
      en_US: 'Back',
      de_DE: 'Zurück',
      el_GR: 'πίσω',
      es_ES: 'Regresa',
      fr_FR: 'Retourner',
      fr_CA: 'Retourner',
      it_IT: 'Torna Indietro',
      pl_PL: 'Wróć',
      th_TH: 'กลับไป',
      zh_CN: '回去',
      pt_BR: 'Volte',
      ja_JP: '戻る',
    },
    stepText: {
      en_US: 'Enter the verification code we just texted to you.',
      de_DE: 'Geben Sie den Bestätigungscode ein, den wir Ihnen gerade geschrieben haben.',
      el_GR: 'Εισαγάγετε τον κωδικό επαλήθευσης που μόλις σας στείλαμε.',
      es_ES: 'Ingrese el código de verificación que le acabamos de enviar.',
      fr_FR: 'Entrez le code de vérification que nous venons de vous envoyer par SMS.',
      fr_CA: 'Entrez le code de vérification que nous venons de vous envoyer par SMS.',
      it_IT: 'Inserisci il codice di verifica che ti abbiamo appena inviato.',
      pl_PL: 'Wpisz kod weryfikacyjny, który właśnie do Ciebie napisaliśmy.',
      th_TH: 'ป้อนรหัสยืนยันที่เราเพิ่งส่งถึงคุณ',
      zh_CN: '输入我们刚刚发给您的验证码。',
      pt_BR: 'Digite o código de verificação que acabamos de enviar para você.',
      ja_JP: 'テキストメッセージで確認コードを入力してください。',
    },
    resendCodeText: {
      en_US: 'Resend Code',
      de_DE: 'Code erneut senden',
      el_GR: 'Ξαναστείλε τον κωδικό',
      es_ES: 'Reenviar Codigo',
      fr_FR: 'Renvoyer le code',
      fr_CA: 'Renvoyer le code',
      it_IT: 'Codice di rispedizione',
      pl_PL: 'Wyślij kod ponownie',
      th_TH: 'ส่งรหัสอีกครั้ง',
      zh_CN: '重新发送验证码',
      pt_BR: 'Reenviar código',
      ja_JP: 'コードを再送信',
    },
    resendingCodeText: {
      en_US: 'Resending Code...',
      de_DE: 'Code erneut senden...',
      el_GR: 'Επαναλάβετε τον κωδικό...',
      es_ES: 'Reenviar código...',
      fr_FR: 'Renvoyer le code...',
      fr_CA: 'Renvoyer le code...',
      it_IT: 'Codice di rinvio...',
      pl_PL: 'Ponowne wysyłanie kodu...',
      th_TH: 'กำลังส่งรหัสอีกครั้ง',
      zh_CN: '正在重新发送代码...',
      pt_BR: 'Reenviando código...',
      ja_JP: 'コードを再送しています...',
    },
    isRequiredMessage: {
      en_US: 'This field is required',
      de_DE: 'Dieses Feld wird benötigt.',
      el_GR: 'Αυτό το πεδίο απαιτείται.',
      es_ES: 'Este campo es requerido.',
      fr_FR: 'Ce champ est requis.',
      fr_CA: 'Ce champ est requis.',
      it_IT: 'Questo campo è obbligatorio.',
      pl_PL: 'To pole jest wymagane.',
      th_TH: 'ต้องระบุข้อมูลในฟิลด์นี้',
      zh_CN: '这是必填栏。',
      pt_BR: 'Este campo é obrigatório.',
      ja_JP: 'この項目は必須です。',
    }
  };
  return mapping[key][lang];
};